import { pwaService } from '@/shared/lib';

const initPwa = (): void => {
  pwaService.init();
};

export { initPwa };
